import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

export const TabsCont = styled.menu`
  ${({ theme }) => `
    display: flex;
    width: max-content;
    height: ${theme.layout.spacing.deka};
    margin: 0;
    padding: 0;
    background: ${theme.colors.neutral.primary[0]};
    border: 2px solid ${theme.colors.secondary[70]};
    border-radius: ${theme.layout.spacing.nano};
    list-style: none;
  `}
`;

export const TabItem = styled.li``;

interface ITab {
  theme: ITheme;
  isActive: boolean;
}

export const Tab = styled.button<ITab>`
  ${({ theme, isActive }) => `
    display: flex;
    width: 100%;
    height: 100%;
    min-width: 96px;
    padding: ${theme.layout.spacing.nano} ${theme.layout.spacing.mikro};
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: ${theme.layout.spacing.piko};
    background: ${isActive ? theme.colors.secondary[100] : 'transparent'};
    color: ${isActive ? theme.colors.neutral.primary[0] : theme.colors.secondary[100]};
    font-weight: ${isActive ? 700 : 400};
    cursor: pointer;
  `};
`;
